import { render, staticRenderFns } from "./Header.m.vue?vue&type=template&id=45ed43ae&scoped=true"
import script from "./Header.m.vue?vue&type=script&lang=js"
export * from "./Header.m.vue?vue&type=script&lang=js"
import style0 from "./Header.m.vue?vue&type=style&index=0&id=45ed43ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ed43ae",
  null
  
)

export default component.exports